import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { useContext, useEffect, useState } from "react";
import { ClienteContext } from "../contexts/ClienteContext";
import MaskService from "../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";

export default function ModalClienteSocio({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    otherPartners,
    setOtherPartners,

    loadingInputs,
    listUf,
    listCounty,
  } = useContext(ClienteContext);
  const { handleChangeCep } = useClienteController();

  const [name, setName] = useState("");
  const [cpf, setCpf] = useState("");
  const [rg, setRg] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [address, setAddress] = useState("");
  const [district, setDistrict] = useState(null);
  const [uf, setUf] = useState(null);
  const [county, setCounty] = useState(null);
  const [cep, setCep] = useState("");
  const [complement, setComplement] = useState("");
  // eslint-disable-next-line
  const [errorsModal, setErrorsModal] = useState({});

  useEffect(() => {
    if (!rowEdit?.data) return;

    const { data } = rowEdit;

    setName(data.nome || "");
    setCpf(MaskService.toMask("cpf", data.cpf || ""));
    setRg(MaskService.toMask("rg", data.rg || ""));
    setBirthDate(data.data_nascimento || "");
    setAddress(data.endereco || "");
    setDistrict(data.bairro || "");
    setCep(MaskService.toMask("cep", data.cep || ""));
    setComplement(data.complemento || "");
  }, [rowEdit]);

  useEffect(() => {
    if (!rowEdit?.data?.cidade_municipio_codigo) return;

    setCounty(
      listCounty.find(
        (opt) => opt.codigo === rowEdit.data.cidade_municipio_codigo.toString()
      ) || null
    );
  }, [listCounty, rowEdit]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handletOtherPartners = () => {
    let copyOtherPartners = [...otherPartners];

    const body = {
      nome: name,
      cpf: cpf.replace(/[^0-9]+/g, ""),
      rg: rg.replace(/[^0-9]+/g, ""),
      data_nascimento: birthDate,
      endereco: address,
      bairro: district,
      cidade_municipio_codigo: county ? county.codigo : null,
      cep: cep.replace(/[^0-9]+/g, ""),
      complemento: complement,
    };

    let empty = 0;
    Object.keys(body).forEach((chave) => {
      if (!body[chave]) empty += 1;
    });

    if (Object.keys(body).length === empty)
      return notify("Preencha ao menos um campo!");

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...copyOtherPartners];
        copy[rowEdit.index] = body;
        setOtherPartners(copy);
      }
    } else {
      setOtherPartners([...copyOtherPartners, body]);
    }

    setOpen(false);
    setRowEdit(null);
  };

  useEffect(() => {
    if (!county) return setUf(null);

    setUf(listUf.find((u) => u.codibge === county.estado_codigo) || null);
  }, [county, listUf]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container spacing={2}>
            <Grid item justify="center">
              Cadastro de Sócios
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item lg={2} md={4} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.cpf || false}
                helperText={errorsModal.cpf || ""}
                label="CPF"
                value={cpf}
                setValue={setCpf}
                mask="cpf"
              />
            </Grid>

            <Grid item lg={5} md={4} sm={6}>
              <TextFieldErp
                error={errorsModal.name || false}
                helperText={errorsModal.name || ""}
                label="Nome"
                maxLength={50}
                value={name}
                setValue={setName}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={12} xs={12}>
              <TextFieldErp
                error={errorsModal.birthDate ? true : false}
                helperText={errorsModal.birthDate || ""}
                label="Data de Nascimento"
                value={birthDate}
                setValue={setBirthDate}
                type="date"
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.rg || false}
                helperText={errorsModal.rg || ""}
                label="RG"
                value={rg}
                setValue={setRg}
                mask="rg"
              />
            </Grid>

            <Grid item lg={2} md={2} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.cep || false}
                helperText={errorsModal.cep || ""}
                label="CEP"
                maxLength={50}
                value={cep}
                onChange={(e) =>
                  handleChangeCep(e, null, {
                    setCep,
                    setAddress: (value) => setAddress(value.substring(0, 60)),
                    setComplement: (value) =>
                      setComplement(value.substring(0, 60)),
                    setCounty,
                    setUf,
                    setDistrict: (value) =>
                      setDistrict((value || "").substring(0, 60)),
                  })
                }
                mask="cep"
                InputProps={{
                  endAdorment: <SearchIcon onClick={() => {}} />,
                }}
              />
            </Grid>

            <Grid item lg={5} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Endereço"
                maxLength={60}
                value={address}
                setValue={setAddress}
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Complemento"
                maxLength={60}
                value={complement}
                setValue={setComplement}
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.district || false}
                helperText={errorsModal.district || ""}
                label="Bairro"
                maxLength={60}
                value={district}
                setValue={setDistrict}
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs.listCounty || false}
                label="Município"
                value={county}
                setValue={setCounty}
                optionsList={listCounty}
                descriptionField="municipio"
              />
            </Grid>

            <Grid item lg={2} md={3} sm={6} xs={12}>
              <SelectErp
                disabled
                loading={loadingInputs.listUf || false}
                label="Estado"
                value={uf}
                setValue={() => {}}
                optionsList={listUf}
                descriptionField="estado"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handletOtherPartners} />
        </DialogActions>
      </Dialog>
    </>
  );
}
